import { z } from 'zod';

export const PublishedDescriptorGetRequestZod = z.object({
  urn: z.string().trim().min(1),
  environment: z.string().trim().min(1),
});

export const PublishedDescriptorResponseZod = z.object({
  descriptor: z.record(z.unknown()),
});

export type PublishedDescriptorGetRequest = z.infer<
  typeof PublishedDescriptorGetRequestZod
>;

export type PublishedDescriptorResponse = z.infer<
  typeof PublishedDescriptorResponseZod
>;
